export default {
  PROCESSING: 'Gathering details',
  VALIDATING_ORDER: 'Validating order',
  VALIDATING_PAYMENT: 'Validating payment'
};
